import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css, cx } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { Slugify } from '@bd/bdcore-utilities';
import links from './MenuLinks';
import ToggleElementCustom from './ToggleElementCustom';
import { colors, typography } from '../styles';

const styles = css`
  position: absolute;
  top: 100%;
  right: 0;
  left: 0;
  overflow-y: auto;
  z-index: 0;
  background: rgba(46, 67, 109, 0.99);
  transform: translateX(0);
  transition: transform 500ms ease;
  @media (max-width: 992px) {
    &:not(.HeaderMenu-active) {
      transform: translateX(100%);
    }
  }
  @media (min-width: 992px) {
    position: static;
    overflow: visible;
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    transform: none;
    transition: none;
  }
  .HeaderMenu_menuClose {
    display: none;
  }
  .HeaderMenu_menu {
    margin: 0;
  }
  .HeaderMenu_menuItem{
    text-align: left;
    @media(max-width: 992px){
      width: 100%;
      text-align: center;
    }
  }
  .HeaderMenu_menu-primary {
    align-items: left;
    @media (min-width: 992px) {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
  .HeaderMenu_menu-secondary {
    text-align: left;
    @media (min-width: 992px) {
      position: absolute;
      top: 100%;
      right: 0;
      border: .5px solid ${colors.color1Lightest};
      min-width: 100%;
      background-color: ${colors.color1Lighter};
      .HeaderMenu_menuLink {
        white-space: nowrap;
      }
    }
  }
  /* .HeaderMenu_menuItem {} */
  .HeaderMenu_menuItem-primary {
    @media (min-width: 992px) {
      position: relative;
      padding: 7px;
      border-top: 1px solid ${colors.color2Lightest};;
      &:hover{
        &:after{
          content: '';
          position: absolute;
          height: 3px;
          background-color: ${colors.color2Lightest};
          top: 0px;
          left: 0px;
          right: 0px;
        }
      }
    }

  }
  .HeaderMenu_menuItem-secondary {
    background-color: transparent;
    padding: 0;
    a {
      font-size: 18px;
      font-weight: 400;
      padding: 2px 10px;
    }

    @media(max-width: 991px){
      display: flex;
      a {
        font-weight: 400;
        padding: 5px 0;
        font-size: 17px;
      }
    }
  }
  .HeaderMenu_menuItem-desktop {
    @media (max-width: 991.98px) {
      display: none;
    }
  }
  .HeaderMenu_menuItem-mobile {
    @media (min-width: 992px) {
      display: none;
    }
  }
  .HeaderMenu_menuDropdown{
    display: flex;
    flex-direction: column;
  }
  .HeaderMenu_menuDropdown .Toggle_button {
    cursor: pointer;
  }
  .HeaderMenu_menuLink {
    &:hover {
      text-decoration: none;
    }
  }
  .HeaderMenu_menuDropdown .Toggle_button,
  .HeaderMenu_menuLink {
    display: flex;
    font-weight: bold;
    background-color: trasnparent;
  }
  .HeaderMenu_menu-secondary {
    padding: 15px;
  }
  .HeaderMenu_menuDropdown .Toggle_button,
  .HeaderMenu_menuLink-primary {
    font-weight: 600;
    font-family: ${typography.Serif};
    color: ${colors.white};
    text-align: left;
    align-items: left;
    line-height: 14px;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 18px;
    background-color: ${colors.color1Dark};
    width: 100%;
    margin: 0 auto;
    padding: 24px 25px;
    margin-bottom: 2px;
    outline: none;
    @media (min-width: 992px) {
      background-color: transparent;
      font-family: ${typography.Serif};
      font-weight: 600;
      line-height: 1;
      color: ${colors.color1};
      display: flex;
      text-align: center;
      align-items: center;
      height: 43px;
      position: relative;
      letter-spacing: 1.3px;
      margin: 0;
    }
  }
  .HeaderMenu_menuLink-secondary {
    font-family: ${typography.SansSerif};
    text-transform: uppercase;
    color: ${colors.white};
    padding: 12px 0;
    font-size: 28px;
    letter-spacing: 1.5px;
    margin-bottom: 2px;
    @media (min-width: 992px) {
      background-color: transparent;
      color: white;
      padding: 5px 16px 5px 5px;
      font-weight: 700;
      font-size: 16px;
      &:focus {
      }
    }
  }

`;


class HeaderMenu extends React.Component {
  constructor(props) {
    super(props);

    this.toggleMenu = this.handleKeyUp.bind(this);
    this.handleTab = this.handleTab.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);
    this.tabListener = false;

    this.menuLinks = [];
    const len = links.length;
    for (let i = 0; i < len; i += 1) {
      const menuGroup = links[i];
      const useableGroupLinks = [];
      const desktopLinks = [];
      const mobileLinks = [];

      const len2 = menuGroup.menuItems.length;
      for (let j = 0; j < len2; j += 1) {
        const link = menuGroup.menuItems[j];
        const desktopLink = get(link, 'header.desktop') !== false;
        const mobileLink = get(link, 'header.mobile') !== false;
        if (desktopLink) {
          desktopLinks.push(link);
        }
        if (mobileLink) {
          mobileLinks.push(link);
        }
        // if a link has `header: { desktop: false, mobile: false }`,
        // don't even include it in this array
        if (desktopLink || mobileLink) {
          useableGroupLinks.push(link);
        }
      }

      if (useableGroupLinks.length) {
        const filteredGroup = {
          menuName: menuGroup.menuName,
          menuItems: useableGroupLinks,
          _id: menuGroup._id,
        };
        this.menuLinks.push(filteredGroup);
      }
      // **
      if (desktopLinks.length === 1) {
        const onlyLink = desktopLinks[0];
        onlyLink._id = `${onlyLink._id}__new`;
        const newGroup = {
          menuName: `${menuGroup.menuName}__new`,
          menuItems: [onlyLink],
          _id: `primary-${i}__new`,
          desktopOnly: true,
        };
        this.menuLinks.push(newGroup);
      }

      // ** if only one link in menuGroup[i].menuItems is set to show up on desktop/mobile,
      // push it into the menu items array as a primary menu item, so we can make it a clickable
      // link rather than a dropdown with only one item in it
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleFocusOut);
    document.removeEventListener('keyup', this.handleTab);
  }

  setNavRef = ref => {
    this.navRef = ref;
  }

  // if we're on the first or last link/button of our menu,
  // close the menu if we tab out of it
  handleFocusOut(e) {
    if (e.key === 'Tab') {
      if (!this.visibleLinksAndButtons.includes(document.activeElement)) {
        this.props.toggleMenu(false);
        document.removeEventListener('keyup', this.handleTab);
        this.tabListener = false;
      }
      document.removeEventListener('keyup', this.handleFocusOut);
    }
  }

  handleTab(e) {
    if (e.key === 'Tab') {
      const activeElement = document.activeElement;

      // if we're tabbing through the menu…
      if (this.visibleLinksAndButtons.includes(activeElement)) {
        // if we are tabbing forwards and land on the last link, or if we're
        // tabbing backwards and land on the first link, add a special listener
        if ((e.shiftKey && this.firstLinkOrButton === activeElement) ||
           (!e.shiftKey && this.lastLinkOrButton === activeElement)) {
          document.addEventListener('keyup', this.handleFocusOut);
        }
      }
    }
  }

  handleKeyUp(e) {
    if (['Tab', 'Enter', ' '].includes(e.key)) {
      const isMobile = !window.matchMedia('(min-width: 992px)').matches;
      const { isActive } = this.props;

      if (isMobile) {
        // re-find the links and toggle buttons every time tab or enter is pressed because
        // submenus using ToggleElementCustom can be completely added/removed from the DOM
        const linksAndButtons = Array.from(this.navRef.querySelectorAll('.HeaderMenu_menuLink, .Toggle_button'));
        this.visibleLinksAndButtons = linksAndButtons.filter(el => el.offsetParent !== null);
        this.firstLinkOrButton = this.visibleLinksAndButtons[0];
        this.lastLinkOrButton = this.visibleLinksAndButtons[this.visibleLinksAndButtons.length - 1];

        // if the menu was closed and we tabbed into a link/button hidden off-screen, open the menu
        // and add a listener for closing the menu in case we tab right back out of it
        if (!isActive && e.key === 'Tab') {
          this.props.toggleMenu(true);
          document.addEventListener('keyup', this.handleFocusOut);

        // also add listener for closing the menu if we hit enter or spacebar on the final link,
        // in case it's a button for a sub-menu that was open and we just closed it, making it
        // the new final link that should close the menu when tabbing away from it
        } else if (isActive && ['Enter', ' '].includes(e.key)) {
          document.addEventListener('keyup', this.handleFocusOut);
        }

        if (!this.tabListener) {
          document.addEventListener('keyup', this.handleTab);
          this.tabListener = true;
        }
      }
    }
  }


  render() {
    const { isActive } = this.props;
    return (
      <nav className={cx(styles, isActive ? 'HeaderMenu-active' : '')} ref={ref => this.setNavRef(ref)}>
        <ul className="HeaderMenu_menu HeaderMenu_menu-primary list-unstyled">
          {
            this.menuLinks.map(menuGroup => {
              const groupLinks = (menuGroup.menuItems || []);
              if (groupLinks.length) {
                const desktopLinks = groupLinks.filter(link => get(link, 'header.desktop') !== false);
                const mobileLinks = groupLinks.filter(link => get(link, 'header.mobile') !== false);
                return (
                  <li
                    className={[
                      'HeaderMenu_menuItem',
                      'HeaderMenu_menuItem-primary',
                      (menuGroup.mobileOnly ||
                      ((groupLinks.length > 1) && !(desktopLinks.length > 1))) ?
                        'HeaderMenu_menuItem-mobile' : '',
                      (menuGroup.desktopOnly ||
                      ((groupLinks.length > 1) && !(mobileLinks.length > 1))) ?
                        'HeaderMenu_menuItem-desktop' : '',
                    ].join(' ').trim()}
                    key={menuGroup.menuName}
                  >
                    {
                      (() => {
                        if (groupLinks.length > 1) {
                          const menuName = `menu-${Slugify(menuGroup.menuName)}`;
                          return (
                            <ToggleElementCustom
                              className="HeaderMenu_menuDropdown"
                              button={`${menuGroup.menuName}`}
                              onKeyUp={e => this.handleKeyUp(e)}
                            >
                              <ul
                                className={[
                                  'list-unstyled',
                                  'HeaderMenu_menu',
                                  'HeaderMenu_menu-secondary',
                                ].join(' ').trim()}
                                key={`${menuName}-list`}
                              >
                                {
                                  groupLinks.map(link => (
                                    <li
                                      className={[
                                        'HeaderMenu_menuItem',
                                        'HeaderMenu_menuItem-secondary',
                                        get(link, 'header.mobile') === false ? 'HeaderMenu_menuItem-desktop' : '',
                                        get(link, 'header.desktop') === false ? 'HeaderMenu_menuItem-mobile' : '',
                                      ].join(' ').trim()}
                                      key={link._id}
                                    >
                                      {
                                        link.route &&
                                        <Link
                                          className="HeaderMenu_menuLink HeaderMenu_menuLink-secondary"
                                          name={link.route}
                                          onKeyUp={e => this.handleKeyUp(e)}
                                        >{link.text}</Link>
                                      }
                                      {
                                        link.url &&
                                        <a
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          href={link.url}
                                          className="HeaderMenu_menuLink HeaderMenu_menuLink-secondary"
                                        >
                                          {link.text}
                                        </a>
                                      }
                                    </li>
                                  ))
                                }
                              </ul>
                            </ToggleElementCustom>
                          );
                        }
                        return (
                          <Link
                            className="HeaderMenu_menuLink HeaderMenu_menuLink-primary"
                            name={groupLinks[0].route}
                            onKeyUp={e => this.handleKeyUp(e)}
                          >{groupLinks[0].text}</Link>
                        );
                      })()
                    }
                  </li>
                );
              }
              return null;
            })
          }
          {/* <li className="d-lg-none d-flex flex-row justify-content-center">
            {
              get(widget, 'pdf') &&
              <a className="Btn Gold mx-1" href={get(widget, 'pdf.contentUrl')}
              target="_blank" rel="noreferrer noopener">
                Newsletter
              </a>
            }
            <Link className="Btn Gold mx-1" name="resident-login">Residents</Link>
          </li> */}
        </ul>
      </nav>
    );
  }
}

HeaderMenu.propTypes = {
  isActive: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  // widget: PropTypes.object.isRequired,
};

export default withData(
  {
    // widget: 'newsletter',
  },
)(HeaderMenu);



// WEBPACK FOOTER //
// ./src/components/HeaderMenu.js